export default [

    {
        path: '/erros/usuario-nao-habilitado', name: 'usuario-nao-habilitado',
        component: () => import('@/views/error/UsuarioNaoHabilitado.vue'),
        meta: {pageTitle: 'Acesso Negado', owner: false },
    },

]
